const DEDICATED_DISPLAY_HOSTNAME = "display.mem.pm";

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, "");
}

export function buildAppDisplayPath(slug: string, authToken?: string): string {
  const url = new URL(`/display/${encodeURIComponent(slug)}`, "https://app.mem.pm");
  if (authToken) {
    url.searchParams.set("auth", authToken);
  }
  return `${url.pathname}${url.search}`;
}

export function resolveDedicatedDisplayOrigin(): string {
  const configured = (import.meta.env.VITE_DISPLAY_ORIGIN ?? "").trim();
  if (configured) {
    return trimTrailingSlash(configured);
  }

  if (typeof window === "undefined") {
    return `https://${DEDICATED_DISPLAY_HOSTNAME}`;
  }

  const { protocol, hostname, port, origin } = window.location;
  const isLoopback = ["127.0.0.1", "localhost", "::1"].includes(hostname);
  if (isLoopback) {
    return origin;
  }

  if (hostname === "app.mem.pm" || hostname === "mem.pm" || hostname === "www.mem.pm") {
    return `${protocol}//${DEDICATED_DISPLAY_HOSTNAME}${port ? `:${port}` : ""}`;
  }

  return origin;
}

export function buildDedicatedDisplayUrl(slug: string, authToken?: string): string {
  const url = new URL(`/display/${encodeURIComponent(slug)}`, resolveDedicatedDisplayOrigin());
  if (authToken) {
    url.searchParams.set("auth", authToken);
  }
  return url.toString();
}

export const buildDisplayUrl = buildDedicatedDisplayUrl;